import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeStyle as _normalizeStyle, renderList as _renderList, withModifiers as _withModifiers, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "stage-drawer" }
const _hoisted_2 = { class: "drawer-layout" }
const _hoisted_3 = { class: "svg-viewer" }
const _hoisted_4 = { class: "svg-controls" }
const _hoisted_5 = { class: "zoom-level" }
const _hoisted_6 = {
  key: 1,
  class: "no-stage-hint"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = ["viewBox"]
const _hoisted_10 = {
  key: 0,
  class: "draw-hit-area",
  x: "-9999",
  y: "-9999",
  width: "99999",
  height: "99999",
  style: {"fill":"transparent","pointer-events":"none"}
}
const _hoisted_11 = ["d", "onClick"]
const _hoisted_12 = ["transform"]
const _hoisted_13 = ["x", "y", "width", "height", "rx"]
const _hoisted_14 = ["x", "y", "font-size"]
const _hoisted_15 = ["x", "y", "transform", "font-size"]
const _hoisted_16 = ["x", "y", "transform", "font-size"]
const _hoisted_17 = ["d"]
const _hoisted_18 = ["points"]
const _hoisted_19 = ["x1", "y1", "x2", "y2"]
const _hoisted_20 = ["cx", "cy", "onMousedown", "onContextmenu"]
const _hoisted_21 = ["cx", "cy", "onMousedown", "onClick"]
const _hoisted_22 = { class: "stage-panel" }
const _hoisted_23 = { class: "panel-section" }
const _hoisted_24 = { class: "stage-list" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "stage-info" }
const _hoisted_27 = { class: "stage-name" }
const _hoisted_28 = { class: "stage-status" }
const _hoisted_29 = {
  key: 0,
  class: "status-ok"
}
const _hoisted_30 = {
  key: 1,
  class: "status-missing"
}
const _hoisted_31 = { class: "stage-actions" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "no-stages"
}
const _hoisted_34 = {
  key: 0,
  class: "panel-section"
}
const _hoisted_35 = { class: "adjuster-section" }
const _hoisted_36 = { class: "control-group" }
const _hoisted_37 = { class: "value-display" }
const _hoisted_38 = { class: "control-group" }
const _hoisted_39 = { class: "value-display" }
const _hoisted_40 = { class: "control-group" }
const _hoisted_41 = { class: "value-display" }
const _hoisted_42 = { class: "control-group" }
const _hoisted_43 = { class: "value-display" }
const _hoisted_44 = { class: "panel-section" }
const _hoisted_45 = { class: "lot-stage-list" }
const _hoisted_46 = { class: "lot-stage-name" }
const _hoisted_47 = {
  key: 0,
  class: "no-assignments"
}
const _hoisted_48 = { class: "panel-section completion-section" }
const _hoisted_49 = { class: "summary" }
const _hoisted_50 = { class: "summary-item" }
const _hoisted_51 = { class: "summary-value" }
const _hoisted_52 = { class: "summary-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "drawer-header" }, [
      _createElementVNode("h2", null, "Assign Stage Boundaries"),
      _createElementVNode("p", null, "Select a stage from the list, draw its boundary on the map, then assign lots to stages.")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomIn,
            title: "Zoom In"
          }, "+"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleZoomOut,
            title: "Zoom Out"
          }, "−"),
          _createElementVNode("button", {
            class: "btn-icon",
            onClick: $setup.handleResetView,
            title: "Reset View"
          }, "⟲"),
          _createElementVNode("div", _hoisted_5, _toDisplayString(Math.round($setup.zoomLevel * 100)) + "%", 1),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "controls-separator" }, null, -1)),
          (!$setup.isDrawing)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($setup.selectedStage)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      ($setup.hasBoundary($setup.selectedStage._id))
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn-edit",
                            onClick: $setup.startDrawing
                          }, "Edit Boundary"))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn-draw",
                            onClick: $setup.startDrawing
                          }, "Draw Boundary"))
                    ], 64))
                  : (_openBlock(), _createElementBlock("span", _hoisted_6, "← Select a stage first"))
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("button", {
                  class: "btn-finish",
                  onClick: $setup.finishDrawing,
                  disabled: $setup.draftPoints.length < 3
                }, "✓ Finish (" + _toDisplayString($setup.draftPoints.length) + " pts)", 9, _hoisted_7),
                _createElementVNode("button", {
                  class: "btn-cancel-draw",
                  onClick: $setup.cancelDrawing
                }, "✗ Cancel"),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "drawing-hint" }, "Drag edge dots to curve · Click an edge dot to add a point · Right-click a point to remove", -1))
              ], 64))
        ]),
        _createElementVNode("div", {
          class: "svg-container",
          ref: "svgContainer",
          style: _normalizeStyle({ cursor: $setup.isDrawing ? 'crosshair' : ($setup.isDragging ? 'grabbing' : 'grab') }),
          onWheel: _withModifiers($setup.handleWheel, ["prevent"]),
          onMousedown: $setup.handleMouseDown,
          onMousemove: $setup.handleMouseMove,
          onMouseup: $setup.handleMouseUp,
          onMouseleave: $setup.handleMouseUp,
          onClick: $setup.handleContainerClick,
          onDblclick: _withModifiers($setup.handleDoubleClick, ["prevent"]),
          onContextmenu: _withModifiers($setup.handleContextMenu, ["prevent"])
        }, [
          ($setup.svgContent)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "svg-background",
                innerHTML: $setup.svgContent,
                style: _normalizeStyle($setup.svgStyle)
              }, null, 12, _hoisted_8))
            : _createCommentVNode("", true),
          (_openBlock(), _createElementBlock("svg", {
            class: "svg-overlay",
            ref: "svgOverlay",
            style: _normalizeStyle($setup.svgStyle),
            viewBox: $setup.overlayViewBox
          }, [
            ($setup.isDrawing)
              ? (_openBlock(), _createElementBlock("rect", _hoisted_10))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stageBoundaries, (boundary, stageId) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: stageId }, [
                _createElementVNode("path", {
                  class: _normalizeClass(["stage-boundary", { 'boundary-selected': $setup.selectedStage?._id === stageId }]),
                  d: $setup.getBoundaryPath(boundary),
                  style: _normalizeStyle($setup.getBoundaryStyle(stageId)),
                  onClick: _withModifiers(($event: any) => ($setup.selectStageById(stageId)), ["stop"])
                }, null, 14, _hoisted_11),
                (boundary.centroid)
                  ? (_openBlock(), _createElementBlock("g", {
                      key: 0,
                      class: "stage-label-group",
                      transform: $setup.getStageLabelTransform(stageId, boundary.centroid)
                    }, [
                      ($setup.stageLabelBboxes[stageId])
                        ? (_openBlock(), _createElementBlock("rect", {
                            key: 0,
                            class: "stage-label-bg",
                            x: $setup.stageLabelBboxes[stageId].x - $setup.stageLabelPadX,
                            y: $setup.stageLabelBboxes[stageId].y - $setup.stageLabelPadY,
                            width: $setup.stageLabelBboxes[stageId].width + $setup.stageLabelPadX * 2,
                            height: $setup.stageLabelBboxes[stageId].height + $setup.stageLabelPadY * 2,
                            rx: $setup.stageLabelPillRx
                          }, null, 8, _hoisted_13))
                        : _createCommentVNode("", true),
                      _createElementVNode("text", {
                        class: "stage-label",
                        ref_for: true,
                        ref: (el) => { if (el) $setup.stageLabelTextRefs[stageId] = el as SVGTextElement },
                        x: $setup.getStageLabelCenterX(stageId, boundary.centroid),
                        y: $setup.getStageLabelCenterY(stageId, boundary.centroid),
                        "font-size": $setup.stageLabelFontSize,
                        "text-anchor": "middle",
                        dy: "0.35em"
                      }, "Stage " + _toDisplayString($setup.getStageName(stageId)), 9, _hoisted_14)
                    ], 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.assignments, (assignment) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: assignment.elementIndex
              }, [
                ($setup.shouldShowLotNumber(assignment))
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 0,
                      class: "lot-number",
                      x: $setup.getLotNumberCenterX(assignment),
                      y: $setup.getLotNumberCenterY(assignment),
                      transform: $setup.getLotNumberTransform(assignment),
                      "text-anchor": "middle",
                      "dominant-baseline": "middle",
                      "font-size": $setup.LOT_NUMBER_FONT_SIZE
                    }, _toDisplayString($setup.getLotTitle(assignment)), 9, _hoisted_15))
                  : _createCommentVNode("", true),
                ($setup.shouldShowLotSize(assignment))
                  ? (_openBlock(), _createElementBlock("text", {
                      key: 1,
                      class: "lot-size",
                      x: $setup.getLotSizeCenterX(assignment),
                      y: $setup.getLotSizeCenterY(assignment),
                      transform: $setup.getLotSizeTransform(assignment),
                      "text-anchor": "middle",
                      "dominant-baseline": "middle",
                      "font-size": $setup.LOT_SIZE_FONT_SIZE
                    }, _toDisplayString($setup.getLotSize(assignment)), 9, _hoisted_16))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128)),
            ($setup.draftPoints.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  ($setup.draftPoints.length >= 3)
                    ? (_openBlock(), _createElementBlock("path", {
                        key: 0,
                        d: $setup.buildQuadraticShapePath($setup.draftPoints, $setup.draftCurvePoints),
                        style: {"fill":"rgba(255, 107, 53, 0.15)","stroke":"#ff6b35","stroke-width":"2","stroke-dasharray":"5,3","pointer-events":"none"}
                      }, null, 8, _hoisted_17))
                    : _createCommentVNode("", true),
                  ($setup.draftPoints.length === 2)
                    ? (_openBlock(), _createElementBlock("polyline", {
                        key: 1,
                        points: $setup.draftPoints.map(p => `${p.x},${p.y}`).join(' '),
                        style: {"fill":"none","stroke":"#ff6b35","stroke-width":"2","stroke-dasharray":"5,3","pointer-events":"none"}
                      }, null, 8, _hoisted_18))
                    : _createCommentVNode("", true),
                  _createElementVNode("line", {
                    x1: $setup.draftPoints[$setup.draftPoints.length - 1].x,
                    y1: $setup.draftPoints[$setup.draftPoints.length - 1].y,
                    x2: $setup.mouseViewPos.x,
                    y2: $setup.mouseViewPos.y,
                    style: {"stroke":"#ff6b35","stroke-width":"2","stroke-dasharray":"5,3","pointer-events":"none"}
                  }, null, 8, _hoisted_19),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.draftPoints, (point, i) => {
                    return (_openBlock(), _createElementBlock("circle", {
                      key: i,
                      cx: point.x,
                      cy: point.y,
                      r: "6",
                      style: _normalizeStyle({ fill: $setup.draggingPointIndex === i ? '#ff3300' : '#ff6b35', stroke: 'white', strokeWidth: '2', cursor: $setup.draggingPointIndex === i ? 'grabbing' : 'grab', pointerEvents: 'all' }),
                      onMousedown: _withModifiers(($event: any) => ($setup.handlePointMouseDown($event, i)), ["stop"]),
                      onContextmenu: _withModifiers(($event: any) => ($setup.handleRemoveDraftPoint(i)), ["prevent","stop"])
                    }, null, 44, _hoisted_20))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.getDraftEdgeHandles(), (handle) => {
                    return (_openBlock(), _createElementBlock("circle", {
                      class: _normalizeClass(["stage-curve-handle", { curved: handle.curved }]),
                      key: `curve-${handle.edgeIndex}`,
                      cx: handle.x,
                      cy: handle.y,
                      r: "5",
                      onMousedown: _withModifiers(($event: any) => ($setup.handleCurveMouseDown($event, handle.edgeIndex)), ["left","stop"]),
                      onClick: _withModifiers(($event: any) => ($setup.handleCurveHandleClick(handle.edgeIndex)), ["stop"])
                    }, null, 42, _hoisted_21))
                  }), 128))
                ], 64))
              : _createCommentVNode("", true)
          ], 12, _hoisted_9))
        ], 36)
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _cache[7] || (_cache[7] = _createElementVNode("h3", null, "Stages", -1)),
          _createElementVNode("div", _hoisted_24, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.stages, (stage) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["stage-item", { active: $setup.selectedStage?._id === stage._id, 'has-boundary': $setup.hasBoundary(stage._id) }]),
                key: stage._id,
                onClick: ($event: any) => ($setup.selectStage(stage))
              }, [
                _createElementVNode("div", {
                  class: "stage-color-dot",
                  style: _normalizeStyle({ background: $setup.getStageColor(stage) })
                }, null, 4),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, _toDisplayString(stage.title), 1),
                  _createElementVNode("div", _hoisted_28, [
                    ($setup.hasBoundary(stage._id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_29, "✓ Boundary drawn"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_30, "No boundary"))
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  ($setup.hasBoundary(stage._id))
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn-clear-boundary",
                        onClick: _withModifiers(($event: any) => ($setup.clearBoundary(stage._id)), ["stop"]),
                        title: "Clear boundary"
                      }, "×", 8, _hoisted_32))
                    : _createCommentVNode("", true)
                ])
              ], 10, _hoisted_25))
            }), 128))
          ]),
          ($props.stages.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("p", null, "No stages found for this estate.", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        ($setup.selectedStage && $setup.hasBoundary($setup.selectedStage._id))
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _createElementVNode("h3", null, "Adjust Label: " + _toDisplayString($setup.getStageName($setup.selectedStage._id)), 1),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", null, "Position X", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.stageLabelAdjustments.offsetX) = $event)),
                    type: "range",
                    min: "-200",
                    max: "200",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.stageLabelAdjustments.offsetX,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_37, _toDisplayString($setup.stageLabelAdjustments.offsetX) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", null, "Position Y", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.stageLabelAdjustments.offsetY) = $event)),
                    type: "range",
                    min: "-200",
                    max: "200",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.stageLabelAdjustments.offsetY,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_39, _toDisplayString($setup.stageLabelAdjustments.offsetY) + "px", 1)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _cache[10] || (_cache[10] = _createElementVNode("label", null, "Scale", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.stageLabelAdjustments.scale) = $event)),
                    type: "range",
                    min: "0.5",
                    max: "3",
                    step: "0.1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.stageLabelAdjustments.scale,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_41, _toDisplayString($setup.stageLabelAdjustments.scale.toFixed(1)) + "x", 1)
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _cache[11] || (_cache[11] = _createElementVNode("label", null, "Rotation", -1)),
                  _withDirectives(_createElementVNode("input", {
                    class: "control-input",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.stageLabelAdjustments.rotation) = $event)),
                    type: "range",
                    min: "0",
                    max: "360",
                    step: "1"
                  }, null, 512), [
                    [
                      _vModelText,
                      $setup.stageLabelAdjustments.rotation,
                      void 0,
                      { number: true }
                    ]
                  ]),
                  _createElementVNode("span", _hoisted_43, _toDisplayString($setup.stageLabelAdjustments.rotation) + "°", 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_44, [
          _cache[13] || (_cache[13] = _createElementVNode("h3", null, "Lots by Stage", -1)),
          _createElementVNode("div", _hoisted_45, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.lotStageItems, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.elementIndex,
                class: "lot-stage-entry"
              }, [
                _createElementVNode("div", {
                  class: "lot-stage-dot",
                  style: _normalizeStyle({ background: item.stageColor })
                }, null, 4),
                _createElementVNode("div", _hoisted_46, "Lot " + _toDisplayString(item.lotTitle), 1),
                _createElementVNode("div", {
                  class: "lot-stage-badge",
                  style: _normalizeStyle({ background: item.stageColor })
                }, _toDisplayString(item.stageTitle), 5)
              ]))
            }), 128))
          ]),
          ($setup.lotStageItems.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [...(_cache[12] || (_cache[12] = [
                _createElementVNode("p", null, "No lots assigned yet. Complete the previous step first.", -1)
              ]))]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, _toDisplayString($setup.drawnBoundariesCount), 1),
              _createElementVNode("div", _hoisted_52, "of " + _toDisplayString($props.stages.length) + " stages have boundaries", 1)
            ])
          ]),
          _createElementVNode("button", {
            class: "btn-primary-large",
            onClick: $setup.handleComplete
          }, "Continue to Estate Boundary →")
        ])
      ])
    ])
  ]))
}